export default function isWebMoneyWalletNumberValid(number) {
  return number.length === 13;
}
